import { render, staticRenderFns } from "./blame_commit_info.vue?vue&type=template&id=d9845d70"
import script from "./blame_commit_info.vue?vue&type=script&lang=js"
export * from "./blame_commit_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports